import React from 'react';
import PropTypes from 'prop-types';

import ProfilePhoto from './profile_photo';

const LabeledProfilePhoto = ({ initials, label, photoUrl, value }) => {
  return (
    <div className="d-flex align-items-center gap-2">
      <span className="text-muted text-uppercase">{label ? `${label}:` : ''}</span>
      <ProfilePhoto initials={initials} photoUrl={photoUrl} value={value}/>
    </div>
  );
};

LabeledProfilePhoto.propTypes = {
  initials: PropTypes.string,
  label: PropTypes.string.isRequired,
  photoUrl: PropTypes.string,
  value: PropTypes.string.isRequired
};

export default LabeledProfilePhoto;
